export const state = () => ({
	isOpen: false,

	citiesList: {}
});

export const mutations = {
	setOpen(state, isOpen) {
		state.isOpen = isOpen;
	},

	setCitiesList(state, citiesList) {
		state.citiesList = citiesList;
	}
};
